"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _styledComponents = require("styled-components");
var _actions = require("../../../actions");
var _selectors = require("../../../selectors");
var _types = require("../../../actions/types");
var _dsIcons = require("@olxbr/ds-icons");
var _dsWeb = require("@olxbr/ds-web");
var _molecules = require("../../molecules");
var _Input = _interopRequireDefault(require("../../ui/Input"));
var _platform = require("../../../helpers/platform");
var _SecuritySendPhoneModal = require("../SecuritySendPhoneModal");
var _lurker = _interopRequireDefault(require("../../../helpers/lurker"));
var _regexValidator = require("../../../helpers/regexValidator");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MessageInputBarFields = /*#__PURE__*/function (_Component) {
  function MessageInputBarFields(props) {
    var _this;
    _classCallCheck(this, MessageInputBarFields);
    _this = _callSuper(this, MessageInputBarFields, [props]);
    _defineProperty(_this, "skipUpdateInput", false);
    _defineProperty(_this, "getPlaceholder", function () {
      return 'Digite uma mensagem...';
    });
    _defineProperty(_this, "focusInput", function () {
      if (!_platform.isMsite && _this.textInputRef) {
        var focusChatInputDoneAction = _this.props.focusChatInputDoneAction;
        _this.textInputRef.focus();
        focusChatInputDoneAction();
      }
    });
    _defineProperty(_this, "textInputRef", null);
    _defineProperty(_this, "messageToBeSent", '');
    _defineProperty(_this, "clearInput", function () {
      _this.messageToBeSent = '';
      _this.setState({
        hasMessage: false,
        lastIsTyping: 0,
        value: ''
      });
    });
    _defineProperty(_this, "handleSendMessage", function () {
      var hasMessage = _this.state.hasMessage;
      _this.setState({
        textareaFocus: true
      });
      if (!hasMessage) return;
      _this.textInputRef.focus();

      // intercept the message and check if there is a phone number
      var hasPhoneInMessage = (0, _regexValidator.hasPhone)(_this.messageToBeSent);
      var isSendPhoneNumberSecurityModal = _this.props.isSendPhoneNumberSecurityModal;
      if ((isSendPhoneNumberSecurityModal === 'orange' || isSendPhoneNumberSecurityModal === 'purple') && hasPhoneInMessage) {
        _lurker["default"].viewModalSendPhoneMessage({
          chatId: _this.props.chatId
        });
        _this.setState({
          hasPhoneInMessage: true
        });
      } else {
        _this.confirmSendMessage();
      }
    });
    _defineProperty(_this, "confirmSendMessage", function () {
      _this.setState({
        hasPhoneInMessage: false
      });
      _this._sendMessage(_this.messageToBeSent);
      _this.clearInput();
    });
    _defineProperty(_this, "handleKeyPress", function (e) {
      var _ref = e.nativeEvent || {},
        shiftKey = _ref.shiftKey,
        key = _ref.key;
      if (key === 'Enter' && !shiftKey) {
        e.preventDefault();
        e.stopPropagation();
        _this.handleSendMessage();
      }
    });
    _defineProperty(_this, "handleChange", function (event) {
      var target = event.target,
        nativeEvent = event.nativeEvent;
      var value = target && target.value || nativeEvent && nativeEvent.text;
      _this.messageToBeSent = value ? value.trim() : '';
      var hasMessage = _this.messageToBeSent.length > 0;
      var newState = {
        hasMessage: hasMessage,
        initialMessageToInput: undefined,
        value: value
      };
      if (hasMessage && _this._shouldNotifyTyping()) {
        var sendStartTypingAction = _this.props.sendStartTypingAction;
        sendStartTypingAction();
        newState.lastIsTyping = new Date().getTime();
      }
      _this.setState(newState);
    });
    _defineProperty(_this, "_sendMessage", function () {
      var messageText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var sendMessageAction = _this.props.sendMessageAction;
      if (!messageText) return;
      var trim = function trim() {
        var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return str.trim();
      };
      var message = trim(messageText);
      sendMessageAction(message, {}, message === _this.initialMessage);
    });
    _defineProperty(_this, "handleRefInput", function (ref) {
      _this.textInputRef = ref;
    });
    _defineProperty(_this, "handleImageUpload", function (file) {
      var uploadImageAction = _this.props.uploadImageAction;
      uploadImageAction(file);
    });
    _defineProperty(_this, "handleBlur", function () {
      _this.setState({
        textareaFocus: false
      });
      _this.props.closeKeyboardAction();
    });
    _defineProperty(_this, "handleFocus", function () {
      _this.setState({
        textareaFocus: true
      });
      _this.props.openKeyboardAction();
    });
    var sellerName = props.sellerName,
      adTitle = props.adTitle;
    _this.state = {
      lastIsTyping: 0,
      hasMessage: false,
      hasPhoneInMessage: false,
      textareaFocus: false,
      value: ''
    };
    _this.initialMessage = "Oi ".concat(sellerName, ", tudo bem? Tenho interesse em saber mais sobre o seu an\xFAncio ").concat(adTitle);
    return _this;
  }
  _inherits(MessageInputBarFields, _Component);
  return _createClass(MessageInputBarFields, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
        initialMessageToInput = _this$props.initialMessageToInput,
        isLoaded = _this$props.isLoaded,
        viewInitialMessageAction = _this$props.viewInitialMessageAction;
      if (!isLoaded) return;
      if (this.skipUpdateInput) {
        return;
      }
      this.skipUpdateInput = true;
      if (initialMessageToInput) {
        this.setState({
          value: this.initialMessage,
          hasMessage: true
        });
        this.messageToBeSent = this.initialMessage;
        viewInitialMessageAction();
      }
    }
  }, {
    key: "_shouldNotifyTyping",
    value: function _shouldNotifyTyping() {
      var lastIsTyping = this.state.lastIsTyping;
      var currentTimestamp = new Date().getTime();
      return (currentTimestamp - lastIsTyping) / 1000 >= 5;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        hasMessage = _this$state.hasMessage,
        hasPhoneInMessage = _this$state.hasPhoneInMessage,
        value = _this$state.value;
      var _this$props2 = this.props,
        chatId = _this$props2.chatId,
        isSendPhoneNumberSecurityModal = _this$props2.isSendPhoneNumberSecurityModal,
        isImageUploadEnabled = _this$props2.isImageUploadEnabled,
        imageUploadCtaAction = _this$props2.imageUploadCtaAction,
        focusChatInput = _this$props2.focusChatInput;
      var placeholder = this.getPlaceholder();
      if (focusChatInput) {
        this.focusInput();
      }
      return [/*#__PURE__*/(0, _jsxRuntime.jsx)(_molecules.ImageUploadInput, {
        onFileSelected: this.handleImageUpload,
        clickImageCTA: imageUploadCtaAction,
        isImageUploadEnabled: isImageUploadEnabled && !hasMessage
      }, 'image-upload'), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
        htmlFor: "input-text-message"
      }, 'label-for-input-text-message'), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], {
        id: "input-text-message",
        placeholder: placeholder,
        ref: this.handleRefInput,
        onChange: this.handleChange,
        onKeyPress: this.handleKeyPress,
        shouldClear: !hasMessage,
        hasText: hasMessage,
        value: value,
        autoFocus: true,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      }, 'input-text-message'), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SentWrapper, {
        hasMessage: hasMessage,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
          icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Sent2, {
            color: "var(--color-primary-100)"
          }),
          onClick: this.handleSendMessage,
          onBlur: this.handleBlur,
          hideVisibleLabel: true,
          label: "Enviar mensagem"
        })
      }, 'sent-button'), hasPhoneInMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SecuritySendPhoneModal.SecuritySendPhoneModal, {
        isOpen: hasPhoneInMessage,
        callbackSendPhone: this.confirmSendMessage,
        callbackNotSendPhone: function callbackNotSendPhone() {
          return _this2.setState({
            hasPhoneInMessage: false
          });
        },
        chatId: chatId,
        variantColor: isSendPhoneNumberSecurityModal
      }, 'modal-phone-send-security')];
    }
  }]);
}(_react.Component);
_defineProperty(MessageInputBarFields, "propTypes", {
  theme: _propTypes.object.isRequired,
  sendMessageAction: _propTypes.func.isRequired,
  cleanInitialMessageAction: _propTypes.func.isRequired,
  sendStartTypingAction: _propTypes.func.isRequired,
  focusChatInputDoneAction: _propTypes.func.isRequired,
  focusChatInput: _propTypes.bool,
  initialMessageToInput: _propTypes.bool.isRequired,
  uploadImageAction: _propTypes.func,
  openKeyboardAction: _propTypes.func,
  closeKeyboardAction: _propTypes.func,
  viewInitialMessageAction: _propTypes.func,
  textareaFocus: _propTypes.bool
});
_defineProperty(MessageInputBarFields, "defaultProps", {
  focusChatInput: false,
  textareaFocus: false
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var ui = state.ui;
  var theme = ownProps.theme;
  var isImageUploadEnabled = (0, _selectors.isChatValidToUploadImage)(state) && (0, _selectors.hasPartnerMessages)(state) && theme.brand === 'olx';
  var buttons = (0, _selectors.getButtons)(state);
  return {
    focusChatInput: !ui || ui.message === _types.UI.FOCUS_CHAT_INPUT,
    initialMessageToInput: !(0, _selectors.hasMyMessages)(state) && (0, _selectors.isInitialMessageEnabled)(state),
    sellerName: (0, _selectors.getCurrentPartnerName)(state),
    adTitle: (0, _selectors.getCurrentChat)(state).subject,
    chatId: (0, _selectors.getChatId)(state),
    isSendPhoneNumberSecurityModal: (0, _selectors.sendPhoneNumberSecurityModal)(state),
    isImageUploadEnabled: isImageUploadEnabled,
    isLoaded: buttons !== undefined
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    sendMessageAction: _actions.sendMessage,
    sendStartTypingAction: _actions.sendStartTyping,
    focusChatInputDoneAction: _actions.focusChatInputDone,
    cleanInitialMessageAction: _actions.cleanInitialMessage,
    imageUploadCtaAction: _actions.imageUploadCTA,
    uploadImageAction: _actions.uploadImage,
    openKeyboardAction: _actions.openKeyboard,
    closeKeyboardAction: _actions.closeKeyboard,
    viewInitialMessageAction: _actions.viewInitialMessage
  }, dispatch);
};
var _default = exports["default"] = (0, _styledComponents.withTheme)((0, _actions.connect)(mapStateToProps, mapDispatchToProps)(MessageInputBarFields));